import { render, staticRenderFns } from "./SeminarList.vue?vue&type=template&id=083fb33a&scoped=true&"
import script from "./SeminarList.vue?vue&type=script&lang=js&"
export * from "./SeminarList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083fb33a",
  null
  
)

export default component.exports